import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { HttpErrorResponse } from "../../../types/responses";
import { useApiPssDeleteAssigneeDetails } from "../datasources/_pss.assignee-details.api.slice";

const usePssDeleteAssigneeDetailsRepo = () => {
  const [api, repository] = useApiPssDeleteAssigneeDetails();
  const httpError = repository.error
    ? ((repository.error as FetchBaseQueryError).data as HttpErrorResponse)
    : undefined;

  return [
    {
      ...repository,
      error: httpError,
    },
    api,
  ] as const;
};

export default usePssDeleteAssigneeDetailsRepo;
